const dataListStatusMap = { // 1草稿2未发布3已发布
    1: '草稿',
    2: '未发布',
    3: '已发布'
};
// 推送状态:1.未开始 2.成功 3.失败
const pushStatus = {
    1: '未开始',
    2: '成功',
    3: '失败',
};
// 任务完成情况:1.未开始 2.进行中 3.已完成
const taskStatus = {
    1: '未开始',
    2: '学习中',
    3: '已完成',
};

// 业务类型:1.课程,2:专题,3:考试
const businessType = {
    1: '课程',
    2: '专题',
    3: '考试',
};
// 推送之前是否已经注册，0-否 1-是
const isRegister = {
    0: '否',
    1: '是',
};
// 学习状态，0-未开始，1-学习中，2-已完成，3-已放弃 ，4-标记完成
const courseStudyFinishStatus = {
    0: '未开始',
    1: '学习中',
    2: '已完成',
    3: '已放弃',
    4: '标记完成',
};
// 专题类型：0 普通, 1.个性化,2学习地图,3 外部专题
const subjectTypeMap = {
    0: '普通',
    1: '个性化',
    2: '学习地图',
    3: '外部专题',
};

export default {
    dataListStatusMap,
    pushStatus,
    taskStatus,
    businessType,
    isRegister,
    courseStudyFinishStatus,
    subjectTypeMap
};
